var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.677 16.385L9.415 10.123C8.915 10.549 8.34 10.8787 7.69 11.112C7.04 11.3453 6.38667 11.462 5.73 11.462C4.12867 11.462 2.77333 10.9077 1.664 9.799C0.554667 8.69034 0 7.33534 0 5.734C0 4.13267 0.554 2.777 1.662 1.667C2.77 0.557002 4.12467 0.00133573 5.726 2.39808e-06C7.32733 -0.00133094 8.68333 0.553336 9.794 1.664C10.9047 2.77467 11.46 4.13034 11.46 5.731C11.46 6.42567 11.337 7.098 11.091 7.748C10.845 8.398 10.5217 8.954 10.121 9.416L16.383 15.677L15.677 16.385ZM5.731 10.461C7.05767 10.461 8.17767 10.0043 9.091 9.091C10.0043 8.17767 10.461 7.05734 10.461 5.73C10.461 4.40267 10.0043 3.28267 9.091 2.37C8.17767 1.45734 7.05767 1.00067 5.731 1C4.40433 0.999336 3.284 1.456 2.37 2.37C1.456 3.284 0.999333 4.404 1 5.73C1.00067 7.056 1.45733 8.176 2.37 9.09C3.28267 10.004 4.40267 10.4607 5.73 10.46",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.caa4256cf1f66658fb432a1d3fb6a2e9.svg";
export { ForwardRef as ReactComponent };